export const classNames = {
    WP_BLOCK_EMBED_YOUTUBE: 'wp-block-embed-youtube',
    WP_BLOCK_EMBED_WRAPPER: 'wp-block-embed__wrapper'
};

export const youtubeUrlRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;